/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContractMedications
 */
export interface ContractMedications {
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractMedications
     */
    specific_medications: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ContractMedications
     */
    individual_daily_price_threshold: number;
    /**
     * 
     * @type {number}
     * @memberof ContractMedications
     */
    cumulative_daily_price_threshold: number;
}

/**
 * Check if a given object implements the ContractMedications interface.
 */
export function instanceOfContractMedications(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "specific_medications" in value;
    isInstance = isInstance && "individual_daily_price_threshold" in value;
    isInstance = isInstance && "cumulative_daily_price_threshold" in value;

    return isInstance;
}

export function ContractMedicationsFromJSON(json: any): ContractMedications {
    return ContractMedicationsFromJSONTyped(json, false);
}

export function ContractMedicationsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractMedications {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specific_medications': json['specific_medications'],
        'individual_daily_price_threshold': json['individual_daily_price_threshold'],
        'cumulative_daily_price_threshold': json['cumulative_daily_price_threshold'],
    };
}

export function ContractMedicationsToJSON(value?: ContractMedications | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specific_medications': value.specific_medications,
        'individual_daily_price_threshold': value.individual_daily_price_threshold,
        'cumulative_daily_price_threshold': value.cumulative_daily_price_threshold,
    };
}

